import { Menu, Tab } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import MetaData from './MetaData';
import TechMetaData from './TechMetaData';
import PhysicalMetaData from './PhysicalMetaData';
import Circuit from './Circuit_HFC/index';
import { useStore } from '../../../app/stores/store';
import '../../../app/common/MediaQuery/responsive-view-page.css';
import { useEffect, useState } from 'react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import ScheduleMetaData from './Schedule/ScheduleMetaData';
import MovementTracker from './HistoryDetails/MovementTracker';
import CircuitHistory from './Circuit_History';

export default observer(function ActivityDetailedSidebar({
  actId,
  title,
  elementType,
}: {
  actId: string;
  title: string;
  elementType: string;
}) {
  const {
    viewStore: { getTechnicalMetadata, technicalMetadata, parentMetadata, hfcMetadata },
    commonStore,
    userStore,
  } = useStore();
  const [loadingd, setLoadingd] = useState(true);
  const [defaultActiveIndex, setDefaultActiveIndex] = useState<number>(0);
  const [isTech, setIsTech] = useState(false);
  const [feID, setFeID] = useState<string[]>([]);

  const [pane, setPane] = useState<any>(null);

  useEffect(() => {
    if (actId) {
      commonStore.hfcCustomerChanges ? hfcMetadata({itemId: actId}) :
      parentMetadata({ itemId: actId });
    }
    // eslint-disable-next-line
  }, [actId]);

  useEffect(() => {
    setLoadingd(true);
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      getTechnicalMetadata({ itemId: actId });
    }
    // eslint-disable-next-line
  }, [actId]);

  useEffect(() => {
    if (technicalMetadata.length > 0) {
      setIsTech(true);
    }
    // eslint-disable-next-line
  }, [technicalMetadata]);

  useEffect(() => {
    const metaComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVF01')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPagesSidebarTabpane
                .AVILVPSTL01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //'Meta Data'
      render: () => (
        <MetaData actId={actId} title={title} elementType={elementType} />
      ),
    };

    const physicalComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVF02')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPagesSidebarTabpane
                .AVILVPSTL03 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //'Physical'
      render: () => <PhysicalMetaData id={actId} />,
    };

    const technicalComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVF03')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPagesSidebarTabpane
                .AVILVPSTL02 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //'Technical'
      render: () => <TechMetaData />,
    };

    const scheduleComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVF04')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPagesSidebarTabpane
                .AVILVPSTL04 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ),
      render: () => <ScheduleMetaData />,
    };

    const circuitComponent = {
      menuItem: <Menu.Item>Circuit</Menu.Item>,
      render: () => <Circuit />,
    };

    const circuitHistoryComponent = {
      menuItem: <Menu.Item>Circuit History</Menu.Item>,
      render: () => <CircuitHistory />,
    };

    let tempPane = [];
    let tempFeID: string[] = [];
    if (
      userStore.user?.customerName === 'NFAI' &&
      window.innerWidth < 1025 &&
      window.innerWidth > 1020
    ) {
      tempPane = [];
      tempFeID = [];
      tempPane.push(metaComponent);
      tempFeID.push('AVLAVF01');
    } else {
      if (!commonStore.filterModeTwo?.includes('AVLAVF01')) {
        tempPane.push(metaComponent);
        tempFeID.push('AVLAVF01');
      }
      if (!commonStore.filterModeTwo?.includes('AVLAVF02')) {
        tempPane.push(physicalComponent);
        tempFeID.push('AVLAVF02');
      }
      if (!commonStore.filterModeTwo?.includes('AVLAVF03') && isTech) {
        tempPane.push(technicalComponent);
        tempFeID.push('AVLAVF03');
      }
      if (!commonStore.filterModeTwo?.includes('AVLAVF04')) {
        tempPane.push(scheduleComponent);
        tempFeID.push('AVLAVF04');
      }
    }

    if (commonStore.hfcCustomerChanges) {
      tempPane.push(circuitComponent);
    }

    if(commonStore.hfcCustomerChanges){
      tempPane.push(circuitHistoryComponent)
    }

    setPane(tempPane);
    setFeID(tempFeID);
    // eslint-disable-next-line
  }, [isTech, commonStore.filterModeTwo, commonStore.filterModeZero, actId]);

  useEffect(() => {
    if (commonStore.filterModeZero?.includes('AVLAVD01')) {
      setDefaultActiveIndex(0);
    } else {
      var index = 0;
      for (var id of feID) {
        if (commonStore.filterModeOne.includes(id)) {
          setDefaultActiveIndex(index);
          break;
        }
        index++;
      }
    }
    setTimeout(() => {
      setLoadingd(false);
    }, 300);
    // eslint-disable-next-line
  }, [
    isTech,
    pane,
    commonStore.filterModeZero,
    commonStore.filterModeOne,
    feID,
  ]);

  return loadingd ? (
    <LoadingComponent />
  ) : (
    <>
      {userStore.user?.customerName === 'Museum' && <MovementTracker />}
      <div className="sidebar-tab-container">
        {/* <Grid stretched className={user?.displayName !== "Rujula" ?'':'sidebartabSmall'}> */}
        <Tab
          className="sidebartabsmallactivity"
          panes={pane}
          defaultActiveIndex={defaultActiveIndex}
        />
        {/* </Grid> */}
      </div>
    </>
  );
});
